/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useEffect, useState} from 'react';
import MapBase from "./MapBase";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {getApiUrl, numberWithCommas, arrayToRgb, getLastYear} from "../../utils";
import RMateChartSpecificShip from "./r_mate_chart/RMateChartSpecificShip";
import WidgetShipStats from "./widgets/WidgetShipStats";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYearMonth from "./widgets/WidgetSelectYearMonth";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {WELL_KNOWN_POSITION} from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";


function MapSpecificShip() {

  const [fillColorLegend, setFillColorLegend] = useState([]);
  const [searchYear, setSearchYear] = useState("");

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: '',
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                  선박무선국 수 : ${numberWithCommas(total)}개<br/>`;
        }
        // return undefined일 경우 leaflet 에러남
        return `<span class='fontStyle'>${name}</span><br/> 
                선박무선국 수 : 0개<br/>`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const {total} = (metricObject[code] || {total: 1});
        if (total >= 1) {
          const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
          return PALETTE_YlOrRd_9[index];
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      ton_code_stats_list: ["01", "02", "03", "04", "05"],
      inf_code_stats_list: ["01", "02", "03", "04", "05"],
      div_code_stats_list: ["01", "02", "03", "04"],
      display_code_stats: "01",
    }
  });

  /*
     서버 Ajax 통신을 위해 json을 만듭니다.
  */

  const settingChkRadSvcString = (checkList) => {
    // as-is 의 json 통신을 위한 문자열 만들기
    let JSONList = {
      "data": []
    };

    for (let value of checkList) {
      const jsonValue = {"CHK_VALUE": value};
      JSONList.data.push(jsonValue);
    }
    return JSON.stringify(JSONList);
  };

  // 차트 색을 입히기 위해 라벨 array를 만듭니다.
  const settingLabelListforTon = (tonList) => {

    let labelList = [];
    for (let tonCode of tonList) {
      if (tonCode === '01') labelList.push("2톤 미만");
      else if (tonCode === '02') labelList.push("2~5톤 이하");
      else if (tonCode === '03') labelList.push("5~40톤 이하");
      else if (tonCode === '04') labelList.push("40~100톤 이하");
      else if (tonCode === '05') labelList.push("100톤 초과");
    }
    return labelList;
  };
  const settingLabelListforInf = (infList) => {

    let labelList = [];
    for (let infCode of infList) {
      if (infCode === '01') labelList.push("연해");
      else if (infCode === '02') labelList.push("근해");
      else if (infCode === '03') labelList.push("평수지역");
      else if (infCode === '04') labelList.push("원양");
      else if (infCode === '05') labelList.push("기타");
    }
    return labelList;
  };
  const settingLabelListforDiv = (divList) => {

    let labelList = [];
    for (let divCode of divList) {
      if (divCode === '01') labelList.push("어선");
      else if (divCode === '02') labelList.push("화물선");
      else if (divCode === '03') labelList.push("여객선");
      else if (divCode === '04') labelList.push("기타");
    }
    return labelList;
  };


  // --- 서버 통신을 위한 함수 끝

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    geojsonExtraParams,
    clickedPolygonGeojsonObjects,
    currentDistrictCode,
    setGeojsonExtraParams,
    setCurrentDistrictCode,
    setChartAjaxParams, chartAjaxParams,
    setTableAjaxParams,
  } = mapProps;

  const {display_code_stats} = widgetState;

  useEffect(() => {
    setChartAjaxParams({
      ...chartAjaxParams,
      cmb_gubun_chart: display_code_stats,
    })
  }, [display_code_stats]);


  useEffect(() => {
    const {
      ton_code_stats_list,
      inf_code_stats_list,
      div_code_stats_list,
      display_code_stats,
    } = widgetState;

    const metricObject = {};
    if (dataResponseList.length > 0) {
      /*
        11140: {01:01:04: 1, 02:01:01: 1, 02:03:04: 3, 03:05:04: 3, 05:04:02: 5, …}
       */
      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        for (let [checkCode, stat] of Object.entries(stats)) {
          let tonVal = checkCode.substr(0, 2); // 톤수
          let infVal = checkCode.substr(3, 2); // 항해구역
          let divVal = checkCode.substr(6, 2); // 선종
          if (ton_code_stats_list.includes(tonVal)   // 체크박스의 모든 조건을 만족할 때
            && inf_code_stats_list.includes(infVal)
            && div_code_stats_list.includes(divVal)) {
            const codeVal = firstDataLayer[code][checkCode];
            total += codeVal;
          }
        }
        metricObject[code] = {total};
      }
    }


    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      ////////// ajax new_param 설정////////////
      // 연월 세팅
      const {year, month} = geojsonExtraParams;
      setSearchYear(year);

      if (month < 10) {
        window.searchYear = year.toString() + '0' + month.toString();
      } else {
        window.searchYear = year.toString() + month.toString();
      }

      // 지역정보 표시 방법
      window.cmb_gubun_chart = display_code_stats;

      // json 문자열
      window.chkString01 = settingChkRadSvcString(ton_code_stats_list);
      window.chkString02 = settingChkRadSvcString(inf_code_stats_list);
      window.chkString03 = settingChkRadSvcString(div_code_stats_list);

      // 파라미터 배열
      window.prm_check = ton_code_stats_list;
      window.prm_check2 = inf_code_stats_list;
      window.prm_check3 = div_code_stats_list;
      window.sidoCode = (currentDistrictCode || '').length < 2
        ? ''
        : currentDistrictCode.substr(0, 2);
      window.new_param =
        'sidoCode=' + window.sidoCode +
        '&searchYear=' + window.searchYear +
        '&chkString01=' + window.chkString01 +
        '&chkString02=' + window.chkString02 +
        '&chkString03=' + window.chkString03;

      setChartAjaxParams({
        sidoCode: window.sidoCode,
        searchYear: window.searchYear,
        chkString01: settingChkRadSvcString(ton_code_stats_list),
        chkString02: settingChkRadSvcString(inf_code_stats_list),
        chkString03: settingChkRadSvcString(div_code_stats_list),
        prm_check: ton_code_stats_list,
        prm_check_label: settingLabelListforTon(ton_code_stats_list),
        prm_check2: inf_code_stats_list,
        prm_check2_label: settingLabelListforInf(inf_code_stats_list),
        prm_check3: div_code_stats_list,
        prm_check3_label: settingLabelListforDiv(div_code_stats_list),
        cmb_gubun_chart: display_code_stats,
      });
      ////////// ajax new_param 설정 끝 ///////////////
    }
  }, [dataResponseList, widgetState, geojsonExtraParams, currentDistrictCode]);

  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    } else { // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()].map(colorIndex => {
          const boundary = 0;
          const colorRgb = '#ffffd9';
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    setTableAjaxParams({
      sidoCode: (currentDistrictCode || ''),
      searchEnd: searchYear,
    })
  }, [currentDistrictCode, searchYear]);

  const makeCodeName = (code) => {
    if(code === '01') return '톤수별';
    if(code === '02') return '항해구역별';
    if(code === '03') return '선종별';
    return code;
  }

  const makeColumsByDisplayCode = (code) => {
    const columns = [];
    if(code === '01'){ // 톤수별
      let concatedColumns = columns.concat(
        {title: '지역명', dataIndex: 'gubun_nm', key: 'gubun_nm', width: 140, fixed: 'left'},
        {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt', width: 100, fixed: 'left',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '2톤 미만', dataIndex: 'data_02_01_cnt', key: 'data_02_01_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '2~5톤 이하', dataIndex: 'data_02_02_cnt', key: 'data_02_02_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '5~40톤 이하', dataIndex: 'data_02_03_cnt', key: 'data_02_03_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '40~100톤 이하', dataIndex: 'data_02_04_cnt', key: 'data_02_04_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '100톤 초과', dataIndex: 'data_02_05_cnt', key: 'data_02_05_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        }
      )
      return concatedColumns;
    } else if(code === '02') { // 항해구역별
      let concatedColumns = columns.concat(
        {title: '지역명', dataIndex: 'gubun_nm', key: 'gubun_nm', width: 140, fixed: 'left'},
        {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt', width: 100, fixed: 'left',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '연해', dataIndex: 'data_01_01_cnt', key: 'data_01_01_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '근해', dataIndex: 'data_01_02_cnt', key: 'data_01_02_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '평수지역', dataIndex: 'data_01_03_cnt', key: 'data_01_03_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '원양', dataIndex: 'data_01_04_cnt', key: 'data_01_04_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '기타', dataIndex: 'data_01_05_cnt', key: 'data_01_05_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
      )
      return concatedColumns;
    } else if (code === '03') { // 선종별
      let concatedColumns = columns.concat(
        {title: '지역명', dataIndex: 'gubun_nm', key: 'gubun_nm', width: 140, fixed: 'left'},
        {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt', width: 100, fixed: 'left',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '어선', dataIndex: 'data_03_01_cnt', key: 'data_03_01_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '화물선', dataIndex: 'data_03_02_cnt', key: 'data_03_02_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '여객선', dataIndex: 'data_03_03_cnt', key: 'data_03_03_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
        {title: '기타', dataIndex: 'data_03_04_cnt', key: 'data_03_04_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })
        },
      )
      return concatedColumns;
    }
  }

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true} isHideWidgetMapLayerTypes={true}>
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} onlyLv1={true} />
            <WidgetSelectYearMonth/>
            <Seperator/>
            <WidgetShipStats/>
          </div>
        </WidgetContainer>
      </MapBase>
      <WidgetRisingTabs titleOnInit={["지역별 선박국 현황", `${makeCodeName(display_code_stats)}선박국 현황`]}>
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type3"})}
          type={"type3"}
          getTitle={(layer) => `지역별 선박국 현황`}
          columns={makeColumsByDisplayCode(display_code_stats)}
          horizontalScroll={1600}
        />
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type1"})}
          type={"type1"}
          getTitle={(layer) => `${makeCodeName(display_code_stats)} 선박국 현황`}
          processor={objectList => {
            // display_code_stats => '01' : '톤수별', '02': '항해구역별', '03': '선종별'
            // eslint-disable-next-line array-callback-return
            const rowList = objectList.filter(({data_type}) => {
              if(display_code_stats === '01'){ // 톤수별
                return data_type === 'DATA_TYPE2'
              } else if(display_code_stats === '02') { // 항해구역별
                return data_type === 'DATA_TYPE1'
              } else if(display_code_stats === '03') { // 선종별
                return data_type === 'DATA_TYPE3'
              }
            });
            const columns = [];
            return [columns, rowList];
          }}
          columns={
            // (currendPageData)=> (
              [
            {title: '구분', dataIndex: 'data_comment', key: 'data_comment',
              // render: makeRowSpanRender({columnName: 'data_comment', currentPageData: currendPageData })
            },
            {title: '구분명', dataIndex: 'data_field', key: 'data_field'},
            {title: '무선국 수', dataIndex: 'data_cnt', key: 'data_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })
            },
          ]
            // )
          }
        />
      </WidgetRisingTabs>
      <RMateChartSpecificShip disabled={
        (widgetState.ton_code_stats_list.length === 0) ||
        (widgetState.inf_code_stats_list.length === 0) ||
        (widgetState.div_code_stats_list.length === 0)
      }/>
      {fillColorLegend.length > 0 && <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>}
      <WidgetToolbar/>
    </MapPropsProvider>
  );
}

export default MapSpecificShip;
